export interface TeacherDestination {
  id: 'classroom' | 'prep';
  label: string;
  route: string;
}

export const TEACHER_DESTINATIONS: TeacherDestination[] = [
  {
    id: 'classroom',
    label: 'Til klasseværelset',
    route: '/til-klassevaerelset',
  },
  {
    id: 'prep',
    label: 'Lærerforberedelsen',
    route: '/laererforberedelse',
  },
];
